import {UI, UIElementCleanChild} from "../../stem-core/ui/UIBase";
import {styleRule, StyleSheet} from "../../stem-core/ui/Style";
import {registerStyle} from "../../stem-core/ui/style/Theme";
import {NodeAttributes} from "../../stem-core/ui/NodeAttributes";


class DashboardTitleStyle extends StyleSheet {
    @styleRule
    title = {
        fontSize: 24,
        fontWeight: 300,
        paddingTop: 20,
    }

    @styleRule
    description = {
        fontSize: 16,
        paddingTop: 8,
        paddingBottom: 16,
        color: this.themeProps.TEXT_SECONDARY_COLOR,
    }
}

@registerStyle(DashboardTitleStyle)
export class DashboardDescription extends UI.Element {
    extraNodeAttributes(attr: NodeAttributes) {
        attr.addClass(this.styleSheet.description);
    }
}

interface DashboardTitleOptions {
    title: UIElementCleanChild;
    description?: UIElementCleanChild;
}


@registerStyle(DashboardTitleStyle)
export class DashboardTitle extends UI.Element<DashboardTitleOptions> {
    render() {
        const {styleSheet} = this;
        const {title, description} = this.options;
        return [
            <div className={styleSheet.title}>{title}</div>,
            description && <DashboardDescription>{description}</DashboardDescription>,
        ];
    }
}
